import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Notification from "../components/Notification";
import ProfileDropdown from "../components/ProfileDropdown";
import DailyReport from "../components/DailyReport";
import WeeklyReport from "../components/WeeklyReport";
import MonthlyReport from "../components/MonthlyReport";
import "../styles/Dashboard.css";

const Dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [reportType, setReportType] = useState("daily");
    const [fade, setFade] = useState(true);
    const [username, setUsername] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

    useEffect(() => {
        const storedUsername = localStorage.getItem("username");
        if (!storedUsername) {
            navigate("/login", { replace: true });
        } else {
            setUsername(storedUsername);
        }
    }, [navigate]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 992) {
                setIsSidebarOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const currentDateLabel = useMemo(() => {
        return new Intl.DateTimeFormat("id-ID", {
            weekday: "long",
            day: "2-digit",
            month: "long",
            year: "numeric",
        }).format(new Date());
    }, []);

    if (!username) return null;

    const handleReportChange = (type) => {
        if (type === reportType) return;

        setFade(false);
        setTimeout(() => {
            setReportType(type);
            setFade(true);
        }, 180);
    };

    const isDashboardMainPath =
        location.pathname === "/dashboard" || location.pathname === "/dashboard/";

    const desktopExpandedClass =
        window.innerWidth >= 992
            ? isSidebarOpen
                ? "sidebar-expanded"
                : "sidebar-collapsed"
            : "";

    return (
        <div className={`dashboard-container ${desktopExpandedClass}`}>
            <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

            <div className="dashboard-main">
                <div className="dashboard-header">
                    <div className="header-title">
                        <span className="dashboard-badge">Dashboard Penggunaan Air</span>
                        <h2>Halo, {username}</h2>
                        <p className="header-subtitle">
                            Pantau laporan air harian, mingguan, dan bulanan dengan tampilan
                            yang lebih nyaman di handphone maupun laptop.
                        </p>
                        <p className="header-date">{currentDateLabel}</p>
                    </div>

                    <div className="header-right">
                        <Notification username={username} />
                        <ProfileDropdown username={username} />
                    </div>
                </div>

                <div className="dashboard-content">
                    {isDashboardMainPath ? (
                        <>
                            <div className="report-switcher">
                                <button
                                    onClick={() => handleReportChange("daily")}
                                    className={reportType === "daily" ? "active" : ""}
                                >
                                    Harian
                                </button>
                                <button
                                    onClick={() => handleReportChange("weekly")}
                                    className={reportType === "weekly" ? "active" : ""}
                                >
                                    Mingguan
                                </button>
                                <button
                                    onClick={() => handleReportChange("monthly")}
                                    className={reportType === "monthly" ? "active" : ""}
                                >
                                    Bulanan
                                </button>
                            </div>

                            <div className={`report-container ${fade ? "fade-in" : "fade-out"}`}>
                                {reportType === "daily" && <DailyReport username={username} />}
                                {reportType === "weekly" && <WeeklyReport username={username} />}
                                {reportType === "monthly" && <MonthlyReport username={username} />}
                            </div>
                        </>
                    ) : (
                        <Outlet />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;